<py-overlay-message>
  <h5>{{ message }}</h5>
  <button class="mt-1 link" (click)="onConfirm()">{{ 'common.confirm_action' | cxTranslate }}</button>
</py-overlay-message>
